module.exports = __webpack_public_path__ + "static/img/contract.c3557a0b.png";